export enum Global {
  READ_CONFIGURATION = 1 << 0, // 1
  CUD_CONFIGURATION = 1 << 1, // 2
  DASHBOARD = 1 << 2, // 4
  ALL = READ_CONFIGURATION | CUD_CONFIGURATION | DASHBOARD, // 7
  NONE = 0, // 0
}

export enum Sales {
  READ = 1, // 1
  CREATE = 1 << 1, // 2
  UPDATE = 1 << 2, // 4
  DELETE = 1 << 3, // 8
  EXPORT = 1 << 4, // 16
  IMPORT = 1 << 5, // 32
  ALL = READ | CREATE | UPDATE | DELETE | EXPORT | IMPORT, // 63
  NONE = 0, // 0
}

export enum Purchases {
  READ = 1, // 1
  CREATE = 1 << 1, // 2
  UPDATE = 1 << 2, // 4
  DELETE = 1 << 3, // 8
  EXPORT = 1 << 4, // 16
  IMPORT = 1 << 5, // 32
  ALL = READ | CREATE | UPDATE | DELETE | EXPORT | IMPORT, // 63
  NONE = 0, // 0
}

export enum Inventory {
  READ = 1, // 1
  CREATE = 1 << 1, // 2
  UPDATE = 1 << 2, // 4
  DELETE = 1 << 3, // 8
  EXPORT = 1 << 4, // 16
  IMPORT = 1 << 5, // 32
  ALL = READ | CREATE | UPDATE | DELETE | EXPORT | IMPORT, // 63
  NONE = 0, // 0
}

export enum Configuration {
  READ = 1, // 1
  CREATE = 1 << 1, // 2
  UPDATE = 1 << 2, // 4
  DELETE = 1 << 3, // 8
  ALL = READ | CREATE | UPDATE | DELETE, // 15
  NONE = 0, // 0
}

export enum BusinessModule {
  READ = 1, // 1
  CREATE = 1 << 1, // 2
  UPDATE = 1 << 2, // 4
  DELETE = 1 << 3, // 8
  EXPORT = 1 << 4, // 16
  IMPORT = 1 << 5, // 32
  ALL = READ | CREATE | UPDATE | DELETE | EXPORT | IMPORT, // 63
  NONE = 0, // 0
}

export enum Users {
  READ = 1, // 1
  CREATE = 1 << 1, // 2
  UPDATE = 1 << 2, // 4
  DELETE = 1 << 3, // 8
  EXPORT = 1 << 4, // 16
  IMPORT = 1 << 5, // 32
  ASSIGN_ROLES = 1 << 6, // 64
  MANAGE_PERMISSIONS = 1 << 7, // 128
  ALL = READ | CREATE | UPDATE | DELETE | EXPORT | IMPORT | ASSIGN_ROLES | MANAGE_PERMISSIONS, // 255
  NONE = 0, // 0
}

export enum Accounting {
  READ = 1, // 1
  CREATE = 1 << 1, // 2
  UPDATE = 1 << 2, // 4
  DELETE = 1 << 3, // 8
  EXPORT = 1 << 4, // 16
  IMPORT = 1 << 5, // 32
  ALL = READ | CREATE | UPDATE | DELETE | EXPORT | IMPORT, // 63
  NONE = 0, // 0
}

export enum Subscription {
  READ = 1, // 1
  CREATE = 1 << 1, // 2
  UPDATE = 1 << 2, // 4
  DELETE = 1 << 3, // 8
  EXPORT = 1 << 4, // 16
  IMPORT = 1 << 5, // 32
  MANAGE_PLANS = 1 << 6, // 64
  MANAGE_BILLING = 1 << 7, // 128
  ALL = READ | CREATE | UPDATE | DELETE | EXPORT | IMPORT | MANAGE_PLANS | MANAGE_BILLING, // 255
  NONE = 0, // 0
}
